<script>
import ageDiscountTypes from '../../../variables/itineraryPrices/ageDiscountTypes';

export default {
  name: 'ItineraryPricesGroupPaxRow',
  props: {
    groupPax: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    rowName: {
      type: String,
      required: true,
    },
    mask: {
      type: String,
      required: true,
    },
    singleDigit: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localGroupPax: null,
      localMask: null,
      validationMessage: null,
      localAgeDiscountTypes: ageDiscountTypes.AGE_DISCOUNT_GROUPS,
    };
  },
  created() {
    this.localGroupPax = this.groupPax;
  },
  watch: {
    groupPax: {
      immediate: true,
      handler(value) {
        this.localGroupPax = value;
        this.dynamicMask();
      },
      deep: true,
    },
  },
  methods: {
    setPax(value) {
      this.localGroupPax.text = value.trim();
      this.$emit('input', { index: this.index, value: this.localGroupPax });
    },
    dynamicMask() {
      if (this.singleDigit) {
        this.localMask = '';
      } else {
        this.localMask = '##-##';
      }
    },
  },
};
</script>

<template>
  <div>
    <v-layout row wrap class="pa-2">
      <v-flex xs3 class="mt-4">
        {{ rowName }}: {{ index + 1 }}
      </v-flex>
      <v-flex xs3>
        <v-text-field
          :value="localGroupPax.text"
          :mask="localMask"
          class="mr-5"
          return-masked-value
          @change="setPax"
        />
      </v-flex>
      <v-flex>
        <v-btn
          fab
          small
          color="primary"
          class="right"
          @click="$emit('add', index)"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn
          fab
          small
          color="error"
          :disabled="index === 0"
          class="right"
          @click="$emit('remove', index)"
        >
          <v-icon>remove</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-divider/>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesGroupPaxRow.vue